var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-main',{attrs:{"app":""}},[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"to":"/jukeboxes"}},[_vm._v("All")]),_c('v-tab',{attrs:{"to":"/jukeboxes/my"}},[_vm._v("My Jukeboxes")])],1),_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }